/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUserIdentityImpersonatedBy
 */
export interface OutputUserIdentityImpersonatedBy {
    /**
     * 
     * @type {number}
     * @memberof OutputUserIdentityImpersonatedBy
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputUserIdentityImpersonatedBy
     */
    name: string;
}

/**
 * Check if a given object implements the OutputUserIdentityImpersonatedBy interface.
 */
export function instanceOfOutputUserIdentityImpersonatedBy(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputUserIdentityImpersonatedByFromJSON(json: any): OutputUserIdentityImpersonatedBy {
    return OutputUserIdentityImpersonatedByFromJSONTyped(json, false);
}

export function OutputUserIdentityImpersonatedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUserIdentityImpersonatedBy {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputUserIdentityImpersonatedByToJSON(value?: OutputUserIdentityImpersonatedBy | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

